export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  {
    name: "Products",
    subMenu: [
      // {
      //   name: "Industrial Chemicals",
      //   path: "/business/industrial-chemicals",
      // },
      {
        name: "Automobiles",
        path: "/business/Automobiles",
      },
      {
        name: "Polypropylene",
        path: "/business/polypropylene",
      },
      {
        name: "Construction",
        path: "/business/Construction",
      },
      {
        name: "Tyres",
        path: "/business/tyre",
      },
      {
        name: "Chemicals",
        path: "/business/api-excipients",
      },
      {
        name: "Metals & Mineral Resources",
        path: "/business/metals-minerals",
      },
      {
        name: "Agricultural Commodities",
        path: "/business/agricultural-commodities",
      },
      {
        name: "Edible & Essential Oils",
        path: "/business/edible-essential-oils",
      },
      // {
      //   name: "Cosmetics",
      //   path: "/business/fmcg",
      // },
      {
        name: "EcoPalm Products",
        path: "/business/ecopalm-products",
      },
    ],
  },
  // { name: "Industries We Serve", path: "/industries-we-serve" },
  // { name: "Quality & Compliance", path: "/quality-compliance" },
  { name: "Certificates", path: "/credentials" },
  { name: "Contact", path: "/contact" },
];
